import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import brandAssetsApi from "../api/brandAssetsApi";

interface ApiError {
  detail: string;
}

export const fetchBrandAssetsThunk = createAsyncThunk(
  "brandAssets/fetchAll",
  async (_: void, thunkAPI) => {
    try {
      return await brandAssetsApi.fetchBrandAssets();
    } catch (e: unknown) {
      const error = e as AxiosError<ApiError>;
      return thunkAPI.rejectWithValue(
        error.response?.data?.detail || "Failed to fetch brand assets.",
      );
    }
  },
);
